export default __webpack_public_path__ + "static/media/Spin torre RD_Interactive LightMix0045.fd76ef7f.webp";